import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { Payment } from '@klopotun/contracts';
import { paymentQueries } from './payment-queries.js';

export const usePaymentQuery = (id: string): UseQueryResult<Payment> =>
  useQuery(paymentQueries.detail(id));
